export default __webpack_public_path__ + "static/media/text_nav.d5e21621.svg";